import router from '../router'
import store from '../store'

router.beforeEach((to, from, next) => {
  const token = store.state.token
  // const token = 'false';
  if (token && token != 'false') {
    if (from.name == 'course_detail_list') {
      to.meta.isBack = true;
      to.meta.isRefresh = true;
    }

    next();
  } else {
    setTimeout(function() {
      store.commit('LOGOUT')
      next();
    },1000)
  }
})



// WEBPACK FOOTER //
// ./src/utils/permission.js